import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IAuthResult } from '../auth-result.model';
import { Authority, CommandResult } from '@amdb/drone/shared/models';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeOnBehalfService {

  constructor(private httpClient: HttpClient) { }

  getAuthorizableAuthorities(): Promise<Authority[]> {
    return this.httpClient.get<Authority[]>('/api/v1/auth/authorizable-authorities').toPromise();
  }

  authorizeOnBehalfOf(authorityId: number): Promise<CommandResult<IAuthResult>> {
    return this.httpClient.post<CommandResult<IAuthResult>>('/api/v1/auth/on-behalf-of/' + authorityId, null).toPromise();
  }
}
